import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/shared/api/customFetchBase';

export const rtkApi = createApi({
  reducerPath: 'api',
  baseQuery: customFetchBase,
  tagTypes: [
    'Profile',
    'TeamApplication',
    'Tournaments',
    'TournamentTeam',
    'TournamentMatchRounds',
    'TournamentPenalty',
    'News',
  ],
  endpoints: () => ({}),
});
